var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "#4EBBB8",
    fillOpacity: 0.1,
    stroke: "#4EBBB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 17.625V33.375C36.75 35.2358 35.2358 36.75 33.375 36.75H17.625C15.7642 36.75 14.25 35.2358 14.25 33.375V17.625C14.25 15.7642 15.7642 14.25 17.625 14.25H33.375C35.2358 14.25 36.75 15.7642 36.75 17.625ZM42.375 23.25H39V33.375C39 36.4766 36.4766 39 33.375 39H23.25V42.375C23.25 44.2358 24.7642 45.75 26.625 45.75H42.375C44.2358 45.75 45.75 44.2358 45.75 42.375V26.625C45.75 24.7642 44.2358 23.25 42.375 23.25Z",
    fill: "#4EBBB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCollection);
export default __webpack_public_path__ + "static/media/DeleteCollection.d2d9e1b53c5a4b8f7348145b4891da6c.svg";
export { ForwardRef as ReactComponent };